// Static UI labels (categories are now loaded dynamically via categoriesContext)

export const LANG_LABEL = {
  fr: "FR",
  creole: "Créole",
  en: "EN",
};

export const LEGAL_DISCLAIMER =
  "Nos contenus sont purement éducatifs, destinés à informer et à sensibiliser. Nous ne promouvons ni n'incitons à la consommation de cannabis.";

export const TEMPLATE_LABELS = {
  long_form: "Long-format",
  news: "Actualité",
  educational: "Pédagogique",
  data: "Donnée",
  myth_buster: "Mythe / Réalité",
  case_study: "Étude de cas",
  gallery: "Galerie photo",
  qa: "Interview",
  video: "Vidéo",
  podcast: "Podcast",
  infographic: "Infographie",
};
